import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { images } from '../data/village-data';

export default function RegisterPage() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (password.length < 6) {
      setError('Password must be at least 6 characters');
      return;
    }
    setLoading(true);
    try {
      await register(name, email, password);
      navigate('/quiz');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section data-testid="register-page" className="auth-page" style={{
      backgroundImage: `linear-gradient(rgba(15,10,25,0.7), rgba(15,10,25,0.85)), url(${images.treeOfLife})`,
    }}>
      <div className="auth-card">
        <h1 className="auth-title">Become a Village Manifestor</h1>
        <p className="auth-subtitle">Your journey begins here</p>

        {error && <p data-testid="register-error" className="auth-error">{error}</p>}

        <form onSubmit={handleSubmit} className="auth-form">
          <input
            data-testid="register-name"
            type="text"
            placeholder="Your name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
            className="auth-input"
          />
          <input
            data-testid="register-email"
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="auth-input"
          />
          <input
            data-testid="register-password"
            type="password"
            placeholder="Password (6+ characters)"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="auth-input"
          />
          <button data-testid="register-submit" type="submit" className="village-btn village-btn--primary auth-submit" disabled={loading}>
            {loading ? 'Creating...' : 'Begin My Journey'}
          </button>
        </form>

        <p className="auth-switch">
          Already a Manifestor? <Link to="/login" className="auth-link">Sign in</Link>
        </p>
        <Link to="/life-map" className="auth-skip">Continue as guest</Link>
      </div>
    </section>
  );
}
